module.exports = __webpack_public_path__ + "img/purse.df8df9ef.png";